/**
 * WARNING: This is meant to reflect Loom access status once M2.5 launches.
 *
 * For Beta, check `useIsLoomBetaEnabled` instead
 */
export const useTenantHasLoom = () => {
	// @ts-ignore TODO: Connect to BE API (https://hello.jira.atlassian.cloud/browse/CTIA-2532)
	return !!window.tenantHasLoom;
};
